<template>
  <div class="login">
    <div class="login_cont">
      <div class="login_left">
        <img :src="welcome" alt="" class="left_img" />
      </div>
      <div class="login_right">
        <p class="login_input">
          <input
            type="user"
            v-model="val_user"
            maxlength="12"
            class="input"
            placeholder="请输入用户名"
            title="用户名不能包含汉子，且只能包含大小写字母和下划线"
          />
        </p>
        <p class="login_input">
          <input
            type="password"
            maxlength="16"
            v-model="val_password"
            class="input"
            placeholder="请输入密码"
          />
        </p>
        <div class="container">
          <div class="bar1 bar"></div>
        </div>
        <div class="login_input about_password">
          <span
            ><el-checkbox v-model="checked" @change="change_boolean" /><span
              style="margin-left: 10px"
              >记住密码</span
            ></span
          >
          <span
            @click="dialogVisible = true"
            style="cursor: pointer; text-decoration: #333"
            >忘记密码</span
          >
        </div>
        <el-button
          type="primary"
          class="submit"
          @click="login"
          :loading="isLogin"
          >登录</el-button
        >
      </div>
    </div>
    <!-- 忘记密码弹框 -->
    <div>
      <el-dialog
        :visible.sync="dialogVisible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        :show-close="false"
        width="30%"
        top="15%"
      >
        <div class="modals">
          <div>
            <img src="../../assets/images/wangji.png" alt="#" />
          </div>
          <div class="txt">
            <p>请联系平台管理员</p>
            <p>0951-6916536</p>
          </div>
        </div>
        <i class="el-icon-circle-close icon" @click="dialogVisible = false"></i>
      </el-dialog>
    </div>
    <div class="f_records">
      CopyRight @ 2021 中国共产党平罗县委员会网络安全和信息化委员会办公室
      备案号：<span @click="toNew()" style="cursor: pointer"
        >宁ICP备 2021002403号-1</span
      >
      <span @click="toRecord()" style="cursor: pointer"
        >宁公网安备 64022102000127号-1</span
      >
      技术支持：西部电子商务股份有限公司
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      mm: require("@/assets/images/mm.png"),
      user: require("@/assets/images/user.png"),
      a: require("@/assets/images/a.png"),
      // 大背景
      login_bg: require("@/assets/images/login_background.png"),
      // 欢迎登陆
      welcome: require("@/assets/images/组_15210.png"),
      // 向右双箭头
      icon_right: require("@/assets/images/_20210727175730.png"),
      checked: false,
      val_user: "",
      val_password: "",
      isLogin: false,
    };
  },
  created: function () {
    plDataInterface.baseURL = process.env.API_HOST;
    plOtherDataInterface.baseURL = process.env.API_HOST;
  },
  methods: {
    getCookie() {
      if (
        document.cookie != undefined &&
        document.cookie.indexOf("username") >= 0 &&
        document.cookie.indexOf("password") >= 0
      ) {
        this.val_user = $.cookie("username");
        this.val_password = $.cookie("password");
        this.checked = true;
      }
    },
    //   验证通过
    login() {
      if ($(".bar1").success() == true) {
        //1.检查界面参数
        if (this.val_user == "" || this.val_password == "") {
          this.$message.error("请输入用户名或密码");
          return false;
        }
        //1.1用户名密码正则验证，通过继续，否则不继续
        if (!this.regex(this.val_user, this.val_password)) {
          this.$message({
            type: "warning",
            message:
              "请输入正确的用户名和密码（密码包含字母、数字和下劃綫，用户名区分大小写）",
          });
          return false;
        }
        //1.2验证用户名密码的正确性,密码正确后在操作token,操作token通过的时候跳转
        if (plDataInterface.regUserPwd(this.val_user, this.val_password)) {
          //2.登录逻辑
          this.isLogin = true;
          let token = $.cookie("token");
          token = plDataInterface.LogIn(this.val_user, this.val_password);
          plOtherDataInterface.Token = token;
          plDataInterface.Token = token;
          var date = new Date();
          date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
          setTimeout(() => {
            // 方法区
            $.cookie("token", token, { expires: date, Path: "/" });
            this.isLogin = false;
            this.$router.push("/home");
          }, 500);
        } else {
          this.$message({ message: "用户名、密码错误", type: "error" });
          this.val_password = "";
          this.val_user = "";
          return false;
        }
      } else {
        this.$message({ message: "滑动失败", type: "warning" });
        return false;
      }
      if (this.checked == true) {
        $.cookie("username", this.val_user, { Path: "/" });
        $.cookie("password", this.val_password, { Path: "/" });
      } else if (this.checked == false) {
        $.removeCookie("username");
        $.removeCookie("password");
      }
    },
    regex(user, pwd) {
      var reg = /^[a-zA-Z\d]+$/;
      var reg1 = /^[a-z\d]+$/;
      if (reg.test(pwd) && reg1.test(user)) {
        return true;
      } else {
        return false;
      }
    },
    move() {
      $(".bar1").slideToUnlock();
    },
    change_boolean() {
      this.checked != this.checked;
    },
    toNew() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    toRecord(){
      window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=64022102000127");
    }
  },
  mounted() {
    this.move();
    this.getCookie();
  },
};
</script>

<style lang="less" scoped>
* {
  font-family: "微软雅黑";
  font-size: 16px;
  border: 0;
  padding: 0;
  margin: 0;
  color: #666;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
input {
  outline: none;
}
.login_cont {
  width: 78.25rem;
  height: 33.625rem;
  display: flex;
  background: #fff;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.login_left,
.login_right {
  width: 50%;
  height: inherit;
}
.login_left {
  background: url("../../assets/images/组.png");
  background-size: 100% 100%;
  position: relative;
}
.login_input {
  width: 300px;
  height: 40px;
  margin: 20px auto;
}
.login_right {
  padding-top: 70px;
}
.login_right .input {
  display: block;
  width: 100%;
  height: inherit;
  border: 1px solid rgb(224, 224, 224);
  background: rgb(244, 244, 244);
  border-radius: 5px;
  padding-left: 10px;
}
.submit {
  width: 300px;
  height: 40px;
  margin: auto;
  background: rgb(88, 195, 138);
  text-align: center;
  // line-height: 40px;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  border-radius: 10px;
  padding: 0 15%;
}
.about_password {
  display: flex;
  font-size: 10px;
  justify-content: space-between;
}
.login {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background: url("../../assets/images/Canvas.png");
  background-size: 100% 100%;
}
.left_img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 276px;
  height: 116px;
  transform: translate(-50%, -50%);
}
.login_move {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  border: 1px solid rgb(224, 224, 224);
}
._bg {
  background: rgb(233, 233, 233);
  text-align: center;
  line-height: 40px;
  position: relative;
  color: rgb(120, 121, 121);
}
.modals {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .txt {
    p {
      font-size: 25px;
      color: #fff;
      text-align: center;
    }
  }
}
.icon {
  font-weight: normal;
  font-size: 40px;
  color: #fff;
  position: absolute;
  right: 0;
  left: 0;
  bottom: -50px;
  margin: auto;
}
/deep/.el-dialog {
  background: #15606e;
  border-radius: 20px;
}
/deep/.el-dialog__header {
  padding: 0;
}
.bar {
  margin-left: 0px;
  height: 40px;
  width: 300px;
}
.bar1 {
  margin-left: 164px;
}

.f_records {
  width: 100%;
  line-height: 35px;
  height: 35px;
  text-align: center;
  background: #00574a;
  font-size: 12px;
  position: fixed;
  bottom: 0px;
  color: #fff;
  left: 0px;
  z-index: 2;
  span {
    font-size: 12px;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue